import { render, staticRenderFns } from "./TaskTypeName.vue?vue&type=template&id=7b0f7d82&scoped=true&"
import script from "./TaskTypeName.vue?vue&type=script&lang=js&"
export * from "./TaskTypeName.vue?vue&type=script&lang=js&"
import style0 from "./TaskTypeName.vue?vue&type=style&index=0&id=7b0f7d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0f7d82",
  null
  
)

export default component.exports